import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 修改信息
export default async function resetPass(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/member/reset_password/confirm', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
